import { LineItemEntryTypeEnum } from 'parkchirp-shared/enums';

function lineItemIsNegative(entryType: LineItemEntryTypeEnum) {
	return [
		LineItemEntryTypeEnum.WRITE_OFF,
		LineItemEntryTypeEnum.PAYMENT,
		LineItemEntryTypeEnum.ADJUSTMENT,
		LineItemEntryTypeEnum.LANDLORD_COLLECTED,
		LineItemEntryTypeEnum.TERMINATION_ADJUSTMENT_NEGATIVE,
	].includes(entryType);
}

export const formatLineItemEntryAmount = (valueInCents, lineItemEntryType = null) => {
	// avoid showing `$NaN`
	if (typeof valueInCents !== 'number') {
		return '';
	}
	let formattedValue = (Math.abs(valueInCents) / 100).toLocaleString('en-US', {
		style: 'currency',
		currency: 'USD',
	});
	const lineItemEntryTypeAsEnum = LineItemEntryTypeEnum[lineItemEntryType];
	if (valueInCents < 0 || lineItemIsNegative(lineItemEntryTypeAsEnum)) {
		// wrap the value in parenthesis since it's a negative value
		formattedValue = `(${formattedValue})`;
	}
	return formattedValue;
};
